package com.havn.app.features.analytics.domain

data class AnalyticsAiInput(
    val language: String,
    val agencyName: String,
    val reportPeriodStart: String,
    val reportPeriodEnd: String,
    val summaryMetrics: AnalyticsAiSummaryMetrics,
    val conversionFunnel: AnalyticsAiConversionFunnel,
    val propertyPerformance: List<AnalyticsAiPropertyPerformance>,
    val agentPerformance: List<AnalyticsAiAgentPerformance>,
    val recentTrends: AnalyticsAiRecentTrends,
    val commonAgentNotes: List<String>
)

data class AnalyticsAiSummaryMetrics(
    val activeProperties: Int,
    val openHousesHosted: Int,
    val totalVisitors: Int,
    val totalLeads: Int,
    val inquiries: Int,
    val generalInquiries: Int,
    val propertyInquiries: Int,
    val leadSources: Map<String, Int>,
    val hotLeads: Int,
    val warmLeads: Int,
    val coldLeads: Int,
    val privateToursRequested: Int,
    val followUpsSent: Int,
    val sellerReportsGenerated: Int,
    val offersRecorded: Int
)

data class AnalyticsAiConversionFunnel(
    val visitors: Int,
    val leads: Int,
    val hotLeads: Int,
    val privateTours: Int,
    val offers: Int
)

data class AnalyticsAiPropertyPerformance(
    val propertyId: String,
    val address: String,
    val openHouses: Int,
    val visitors: Int,
    val leads: Int,
    val hotLeads: Int,
    val privateTours: Int,
    val sellerConfidenceScore: Int
)

data class AnalyticsAiAgentPerformance(
    val agentId: String,
    val name: String,
    val openHousesHosted: Int,
    val visitors: Int,
    val hotLeads: Int,
    val followUpsSent: Int,
    val averageFollowupTimeHours: Double?,
    val privateToursBooked: Int
)

data class AnalyticsAiRecentTrends(
    val visitorChangeVsPreviousPeriodPercent: Int?,
    val hotLeadChangeVsPreviousPeriodPercent: Int?,
    val privateTourChangeVsPreviousPeriodPercent: Int?,
    val followupCompletionChangePercent: Int?
)

interface AnalyticsAiService {
    suspend fun generateInsights(input: AnalyticsAiInput): Result<String>
}
